import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import DignityThroughBasicNeeds from "./sections/DignityThroughBasicNeeds";
import HeritageHospitality from "./sections/HeritageHospitality";
import TheNeighborlyAdvantage from "./sections/TheNeighborlyAdvantage";
import OurPathToIDo from "./sections/OurPathToIDo";
import WordsOfLove from "./sections/WordsOfLove";
import HolDirDenUnbegrenztenTurbo from "./sections/HolDirDenUnbegrenztenTurbo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <DignityThroughBasicNeeds />
      <HeritageHospitality />
      <TheNeighborlyAdvantage />
      <OurPathToIDo />
      <WordsOfLove />
      <HolDirDenUnbegrenztenTurbo />
      <Footer />
    </div>;
}